import { render, staticRenderFns } from "./OnScreenKeyboard.vue?vue&type=template&id=7b1aa7f6&scoped=true&"
import script from "./OnScreenKeyboard.vue?vue&type=script&lang=js&"
export * from "./OnScreenKeyboard.vue?vue&type=script&lang=js&"
import style0 from "./OnScreenKeyboard.vue?vue&type=style&index=0&id=7b1aa7f6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b1aa7f6",
  null
  
)

export default component.exports